import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService } from 'rome-library';
import { States } from './../../shared/constants/states';
import { CaseNavigationService } from './case-navigation.service';
import { StateService } from './state.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class DirectStateService extends StateService {
  constructor(
    private readonly router: Router,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly caseNavigationService: CaseNavigationService,
    private readonly userService: UserService
  ) {
    super();
  }
  public getUserProfileState(): string {
    return States.DirectProfile;
  }

  public getAccessControllerState(): string {
    return undefined;
  }

  public getHelpCenterState(): string {
    return States.CustomerHelpCenter;
  }

  public getAfterLoginState(): string {
    return States.CustomerHub;
  }

  public goToCaseHub(): void {
    const user = this.userService.getUser();

    if (!user.ProfileComplete) {
      void this.router.navigate([this.applicationHostTypeService.getCode(), this.getUserProfileState(), user.UserId]);
    } else {
      void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.CustomerHub]);
    }
  }

  public goToCaseOverview(caseId: string): void {
    this.caseNavigationService.goToCase({
      CaseId: caseId,
      Tab: States.CustomerApplicationOverview
    });
  }

  public goToCaseMessaging(caseId: string): void {
    this.caseNavigationService.goToCase({
      CaseId: caseId,
      Tab: States.CustomerMessaging
    });
  }
}
